<img class="block h-9" src="{{src}}"/>
<span class="block truncate text-gray-600" > &nbsp;{{ name }}</span>
